import { supabase } from '../lib/supabase/client';

export default async function getDonationInvoice(
  paymentId?: string | null
): Promise<string | null> {
  if (!paymentId) {
    console.error('No payment ID provided');
    return null;
  }

  const token = (await supabase.auth.getSession()).data.session?.access_token;
  if (!token) {
    console.error('No authentication token found');
    return null;
  }

  try {
    const {
      data: { invoiceUrl },
      error,
    } = await supabase.functions.invoke(`payments-history/${paymentId}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (error) {
      console.error('Error fetching invoice:', error.message);
      return null;
    }

    return invoiceUrl as string;
  } catch (error) {
    console.error('Unexpected error fetching invoice:', error);
    return null;
  }
}
